/*
 * Lemonade Training Oy, copy rights, all right reserved.
 * LT-2034: the gym's refund attention queue and the owner's visit-card resolution callables.
 */

import { httpsCallable } from "firebase/functions";
import { firebaseFunctions } from "../store/firebaseApp";
import type {
  AdjustVisitCardVisitsRequest,
  AdjustVisitCardVisitsResponse,
  GetRefundsNeedingAttentionRequest,
  GetRefundsNeedingAttentionResponse,
  ResolveRefundReviewRequest,
  ResolveRefundReviewResponse,
} from "@lemonadetraining/contracts";

// async so a synchronous throw inside httpsCallable still reaches the caller's .catch.
export const getRefundsNeedingAttention = async (
  data: GetRefundsNeedingAttentionRequest
): Promise<GetRefundsNeedingAttentionResponse> => {
  const fn = httpsCallable<GetRefundsNeedingAttentionRequest, GetRefundsNeedingAttentionResponse>(
    firebaseFunctions,
    "getRefundsNeedingAttention"
  );
  return (await fn(data)).data;
};

export const adjustVisitCardVisits = async (
  data: AdjustVisitCardVisitsRequest
): Promise<AdjustVisitCardVisitsResponse> => {
  const fn = httpsCallable<AdjustVisitCardVisitsRequest, AdjustVisitCardVisitsResponse>(
    firebaseFunctions,
    "adjustVisitCardVisits"
  );
  return (await fn(data)).data;
};

export const resolveRefundReview = async (
  data: ResolveRefundReviewRequest
): Promise<ResolveRefundReviewResponse> => {
  const fn = httpsCallable<ResolveRefundReviewRequest, ResolveRefundReviewResponse>(
    firebaseFunctions,
    "resolveRefundReview"
  );
  return (await fn(data)).data;
};
